import moment from "moment";

/**
 * Converts a datetime-local input value ("YYYY-MM-DDTHH:mm") into a UTC ISO
 * string that the backend can store deterministically. The browser's local
 * timezone is used for the interpretation, matching what the user sees in the
 * datetime-local picker.
 */
export function scheduleDateToUTC(value) {
  if (!value) return value;
  const parsed = moment(value);
  if (!parsed.isValid()) return value;
  return parsed.utc().toISOString();
}

/**
 * Formats an ISO date string (or Date) for use in a datetime-local input.
 * The result is rendered in the browser's local timezone.
 */
export function scheduleDateToLocalInput(value) {
  if (!value) return "";
  const parsed = moment(value);
  return parsed.isValid() ? parsed.format("YYYY-MM-DDTHH:mm") : "";
}
